<div class="row mx-0">
  <div class="col-9 col-sm-9 col-md-9 col-sm-9 px-2">
    <div class="row justify-content-between align-items-end">
      <div class="col-12 col-sm-2 col-md-2 col-sm-2 px-2">
        <div class="form-group">
          <label>Project Manager</label>
          <select class="form-control select2" #projectManager>
            <option selected="selected" value="">Select All</option>
            <option value="1">Active</option>
            <option value="0">Inactive</option>
          </select>
          <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
            <input type="text" />
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-2 col-md-2 col-sm-2 px-2">
        <div class="form-group">
          <label>Job</label>
          <select class="form-control select2" #job>
            <option selected="selected" value="">Select All</option>
            <option value="1">Active</option>
            <option value="0">Inactive</option>
          </select>
          <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
            <input type="text" />
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-2 col-md-2 col-sm-2 px-2">
        <div class="form-group">
          <label>Facility</label>
          <select class="form-control select2" #facility>
            <option selected="selected" value="">Select All</option>
            <option value="1">Active</option>
            <option value="0">Inactive</option>
          </select>
          <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
            <input type="text" />
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-2 col-md-2 col-sm-2 px-2">
        <div class="form-group">
          <label>Owner</label>
          <select class="form-control select2" #owner>
            <option selected="selected" value="">Select All</option>
            <option value="1">Active</option>
            <option value="0">Inactive</option>
          </select>
          <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
            <input type="text" />
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-2 col-md-2 col-sm-2 px-2">
        <div class="form-group">
          <label>Attributes</label>
          <select class="form-control select2" #attributes>
            <option selected="selected" value="">Select All</option>
            <option value="1">Active</option>
            <option value="0">Inactive</option>
          </select>
          <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
            <input type="text" />
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-2 col-md-2 col-sm-2 px-2">
        <div class="form-group">
          <label>Tags</label>
          <select class="form-control select2" #tags>
            <option selected="selected" value="">Select All</option>
            <option value="1">Active</option>
            <option value="0">Inactive</option>
          </select>
          <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
            <input type="text" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3">
    <div class="row mx-2 justify-content-end">
      <div class="col-8 col-sm-8 col-md-8 col-sm-8 px-2 mt-3">
        <div class="search-box">
          <div class="form-group">
            <input type="text" name="" placeholder="Search" #search class="form-control" />
            <a href="javascript:;" class="search"><i class="fas fa-search"></i></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
